import React, { useEffect, useState } from 'react';
import api from '../utils/api';

export default function ComponentExample({ componentId, name, theme, automatic = false, autoOpen = false }: { componentId: number; name: string; theme: string; automatic?: boolean; autoOpen?: boolean }) {
  const [open, setOpen] = useState(false);
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => { if (autoOpen) setOpen(true); }, [autoOpen, componentId]);
  useEffect(() => {
    if (!open) return;
    let active = true;
    setHtml(''); setError('');
    api.get(`/api/generation/component-example/${componentId}`, { params: { theme } })
      .then(response => { if (active) setHtml(response.data.data.html); })
      .catch(() => { if (active) setError('Не удалось загрузить пример.'); });
    return () => { active = false; };
  }, [componentId, theme, open, attempt]);
  return <div className="wp-componentExample">
    <button className="u2-btn is-secondary" type="button" aria-expanded={open} onClick={() => setOpen(!open)}>{open ? 'Скрыть пример' : 'Посмотреть пример'}</button>
    {open && <div>
      <p className="u2-muted">{automatic ? 'Пример одного из доступных вариантов. При автовыборе вариант может отличаться. ' : ''}Реальная вёрстка блока, демонстрационные тексты и изображения. Интерактивные действия отключены.</p>
      {error ? <p role="alert">{error} <button type="button" className="u2-btn is-secondary" onClick={() => setAttempt(x => x + 1)}>Повторить</button></p> : html ? <iframe title={`Пример: ${name}`} sandbox="" srcDoc={html} /> : <p role="status">Загрузка примера…</p>}
    </div>}
  </div>;
}
